export default __webpack_public_path__ + "static/media/unionBudget.0de5306c.pdf";